import React from 'react';
import QuickbooksConnect from '../../components/QuickbooksConnect/QuickbooksConnect';

const QuickbooksConnectContainer = (props) => <QuickbooksConnect {...props} />;

export default QuickbooksConnectContainer;
